<template>
  <div class="container page">
    <van-nav-bar :title="$t('bindCard.title')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="main-box">
      <div class="label">{{ $t('bindCard.msg') }}</div>
      <van-cell-group>
        <van-field v-model="financial_institution" v-if="false"  :label="$t('bindCard.financial_institution')"  :placeholder="$t('bindCard.truefinancial_institution')" />
        <van-field v-if="banks.length == 0" v-model="branch" :label="$t('银行名称')"  :placeholder="$t('请输入银行名称')" />
        <div class="van-cell van-field" v-else @click="showBank = true" >
          <div class="van-cell__title van-field__label">
            <span>{{ $t('bindCard.branch') }}</span>
          </div>
          <div class="van-cell__value van-field__value" v-if="branch == ''">
            <div class="van-field__body">
              {{ $t("请选择银行") }}
            </div>
          </div>

          <div class="van-cell__value van-field__value" v-else>
            <div class="van-field__body" style="color: #323233">
              {{  branch }}
            </div>
          </div>
        </div>

        <van-field v-model="branch_number" :label="$t('账户持有人')"  :placeholder="$t('请使用英文字母表示用户名。')" />
        <van-field v-model="bankid" :label="$t('账号')" :placeholder="$t('请输入您的账号')" />
        <van-field v-model="bank" v-if="false" :label="$t('bindCard.name')"  :placeholder="$t('bindCard.truename')" />
      </van-cell-group>
      <p>{{ $t("bindCard.hint") }}</p>
    </div>
    <van-button class="bindCard" type="default" @click="bindCard()">{{ $t("msg.确认绑卡") }}</van-button>
    <van-popup v-model="showBank" round position="bottom" :style="{ height: '320px' }" >
      <van-picker
          show-toolbar
          :columns="banks"
          @confirm="onConfirm"
          @cancel="onCancel">
            <template #confirm>
              <span>{{ $t("确定") }}</span>
            </template>
            <template #cancel>
              <span>{{ $t("取消") }}</span>
            </template>
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banks: [],
      showBank:false,
      userInfo:{},
      bankid:"",
      bank:"",
      financial_institution:"",
      branch:"",
      branch_number:"",
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    bindCard(){
      /*if(this.financial_institution === "" || this.financial_institution === null || this.financial_institution === undefined){
        this.$toast(this.$t('bindCard.truefinancial_institution'));
        return true;
      }*/
      if(this.branch === "" || this.branch === null || this.branch === undefined){
        this.$toast(this.$t('bindCard.truebranch'));
        return true;
      }
      if(this.branch_number === "" || this.branch_number === null || this.branch_number === undefined){
        this.$toast(this.$t('bindCard.truebranch_number'));
        return true;
      }
      if(this.bankid === "" || this.bankid === null || this.bankid === undefined){
        this.$toast(this.$t('bindCard.truecard'));
        return true;
      }
      /*if(this.bank === "" || this.bank === null || this.bank === undefined){
        this.$toast.fail(this.$t('bindCard.truename'));
        return false;
      }*/
      this.$http({
        method: 'get',
        data:{bankid:this.bankid,bank:this.bank,financial_institution:this.financial_institution,branch:this.branch,branch_number:this.branch_number},
        url: 'user_set_bank'
      }).then(res=>{
        if(res.code === 200){
          this.$router.push({path:'/Mine'})
        }
        this.$toast(this.$t("msg."+res.msg));
      })
    },
    showSelectBanks(){
      this.showBank = true;
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code ===401){
          this.$toast(this.$t(res.msg));
        }
      })
    },
    getBankList(){
      this.$http({
        method: 'get',
        url: 'sys_get_banks'
      }).then(res=>{
        if(res.code === 200){
          this.banks = res.data;
        }else if(res.code ===401){
          this.$toast(this.$t(res.msg));
        }
      })
    },
    onConfirm(value) {
      this.branch = value.text
      this.showBank = false;
    },
    onCancel() {
      this.showBank = false;
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        if(res.code === 200){
          if(res.data.is_bank){
            this.is_bind = true;
          }else {
            this.is_bind = false;
          }
        }else if(res.code ===401){
          this.$toast(this.$t(res.msg));
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getBankList();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.van-cell {
  font-size: 32px;
  line-height: 80px;
}
.van-hairline--bottom::after {
  border-bottom-width: 3px;
}
.bankbox{
  padding: 15px;
  color: #000;
  background-color: #fff;
}
.bankbox .title{
  padding: 8px 10px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 28px;
}
.main-box{
  background: #fff;

}
.main-box .label{
  padding: 20px;
  font-size: 35px;
  color: #797878;
}
::v-deep .van-picker__toolbar {
  height: 50PX;
}
::v-deep .van-picker__cancel {
  padding: 0 20PX;
  font-size: 15PX;
}
::v-deep .van-picker__confirm {
  padding: 0 20PX;
  font-size: 15PX;
}
::v-deep .van-picker-column {
  font-size: 40px;
}
.main-box p{
  padding: 0 20px;
  font-size: 30px;
  color: #ee0a24;
}
.bindCard {
  margin: 20px 30px 0;
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 10px;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(99.09deg, #66bcff 0%, #ec1d25 100%)
}
</style>
